import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom"; // 1. Import hooks
import "./Common_Send_Button.css";

import Send_Button_Modal from "../common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../common-modals/call-now-modal/Call_Now_Modal";

function Common_Send_Button({ vendor, onClick, onClick2, onClick3 }) {
  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleInquiryClick = () => {
    if (location.pathname === "/" || location.pathname === "/home") {
      navigate("/login");
    } else {
      if (onClick3) onClick3();
      else if (onClick) onClick();
    }
  };
  return (
    <div className="button-section">
      <div className="vendor-buttons">
        <Button className="inquiry-btn" onClick={handleInquiryClick}>
          Send Inquiry
        </Button>
      </div>
    </div>
  );
}

export default Common_Send_Button;
